import styled from "@emotion/styled";

interface Props {
  value: string | number;
}

export const PercentageChip = ({ value }: Props) => {
  return (
    <Container>
      <Chip>
        <Text>{value} %</Text>
      </Chip>
    </Container>
  );
};

const Container = styled.span({
  display: "flex",
});

const Chip = styled.div(({ theme }) => ({
  padding: "0 1rem",
  alignItems: "center",
  borderRadius: "5rem",
  backgroundColor: theme.palette.background.default,
  border: `0.5px solid ${theme.palette.grey[400]}`,
  width: "fit-content",
}));

const Text = styled.p({
  wordBreak: "keep-all",
  fontSize: "0.6rem",
  fontWeight: 600,
});
